import { useState } from 'react';

export default function Hero() {
  const [imgError, setImgError] = useState(false);

  return (
    <section id="hero" className="relative min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-background-950 via-background-900 to-background-950"></div>
      <div className="absolute inset-0 opacity-[0.03] bg-[radial-gradient(circle_at_50%_50%,rgba(255,255,255,0.1)_0%,transparent_60%)]"></div>

      <div className="relative w-full px-4 md:px-6 lg:px-12 pt-[72px] pb-16 md:pb-20">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left pt-8 md:pt-12">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/15 border border-primary-500/25 mb-6">
              <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
              <span className="text-primary-400 text-xs font-medium">每日更新 · 高清流畅</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-background-50 leading-tight mb-5">
              神马视频 · 高清影视大全
            </h1>

            <p className="text-lg md:text-xl text-background-200/80 font-heading mb-5">
              精彩内容，一触即达
            </p>

            <p className="text-sm md:text-base text-background-300/70 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              神马视频汇聚91视频、91在线视频、97视频、51视频等全系列数字视频资源，提供海量电视剧、电影、综艺、动漫、纪录片免费在线观看。高清画质、极速播放、不缓冲、不卡顿，每日更新热门内容，打造您专属的高清影视大全平台。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">10,000+</div>
                <div className="text-xs text-background-400/60 mt-1">视频资源</div>
              </div>
              <div className="w-px h-10 bg-background-400/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">每日更新</div>
                <div className="text-xs text-background-400/60 mt-1">内容新鲜</div>
              </div>
              <div className="w-px h-10 bg-background-400/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">千万用户</div>
                <div className="text-xs text-background-400/60 mt-1">信赖之选</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#topics"
                onClick={(e) => { e.preventDefault(); document.querySelector('#topics')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="w-full sm:w-auto px-7 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
              >
                <i className="ri-fire-line mr-1.5"></i>热门内容
              </a>
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="w-full sm:w-auto px-7 py-3 bg-background-50/10 hover:bg-background-50/20 text-background-50 border border-background-50/20 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
              >
                <i className="ri-medal-line mr-1.5"></i>热播榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            {!imgError ? (
              <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20scene%20with%20warm%20golden%20and%20amber%20lighting%2C%20elegant%20movie%20theater%20interior%20with%20large%20glowing%20screen%20displaying%20abstract%20film%20elements%2C%20plush%20red%20velvet%20seats%2C%20atmospheric%20light%20beams%2C%20luxurious%20and%20sophisticated%20entertainment%20aesthetic%2C%20professional%20editorial%20photography%20with%20soft%20shadows&width=960&height=720&seq=hero-shenma-main&orientation=landscape"
                  alt="神马视频高清影视大全主视觉"
                  title="神马视频 | 91视频、91在线视频免费在线观看全集"
                  className="w-full h-full object-cover"
                  onError={() => setImgError(true)}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/60 via-transparent to-transparent"></div>
              </div>
            ) : (
              <div className="w-full max-w-[480px] aspect-[4/3] rounded-2xl bg-background-800/50 flex items-center justify-center">
                <div className="text-center text-background-400/50">
                  <i className="ri-movie-line text-5xl block mb-2"></i>
                  <span className="text-sm">神马视频</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}